module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded",
    attrs: {
      "id": "toc"
    }
  }, [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("___________________")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1"
    }
  }, [_vm._v("PART I: OUT OF THE PAST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("Welcome to Amsterdam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Michael Berg")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Schiphol Airport")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap2"
    }
  }, [_vm._v("Spui 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Anneloes Timmerije")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Centrum")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ankle Monitor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Herman Koch")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Watergraafsmeer")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("A. Simon de Waal")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Red-Light District")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: KISS ME DEADLY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Hanna Bervoets")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Van der Pekbuurt")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silent Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Karin Amatmoekrim")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Oosterpark")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul Mates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Christine Otten")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Tuindorp Oostzaan")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: TOUCH OF EVIL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil’s Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Mensje van Keulen")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Duivelseiland")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man on the Jetty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Murat Isik")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Bijlmer")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucky Sevens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Theo Capel")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("De Jordaan")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stranger Inside Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Loes den Hollander")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Central Station")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: THEY LIVE BY NIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven Bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Max van Olden")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Grachtengordel")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Girl at the End of the Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Abdelkader Benali")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Sloten")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Rich Quick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Walter van den Berg")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Osdorp")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starry, Starry Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("René Appel & Josh Pachter")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Museum District")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/extra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/usanoir",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('i', [_vm._v("USA NOIR")]), _vm._v(" edited by Johnny Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/noir",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also in Akashic Noir Series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/award",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Akashic Noir Series Awards & Recognition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/akb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Akashic Books")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyrights & Credits")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 63
// module chunks = 0